<template>
  <b-alert class="feedback-wrapper text-center" dismissible :show="true">
    <svg
      class="d-block mx-auto my-2"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style="fill: #fff; transform: ; -ms-filter: "
    >
      <path
        d="M20.664 3.478L8 8v7l.748.267-1.127 2.254c-.26.519-.281 1.123-.06 1.659.223.536.665.949 1.216 1.133l4.084 1.361c.205.068.416.101.624.101.741 0 1.451-.414 1.797-1.104l1.303-2.606 4.079 1.457c.65.233 1.336-.25 1.336-.941V4.419C22 3.728 21.314 3.245 20.664 3.478zM13.493 19.777L9.41 18.416l1.235-2.471 4.042 1.444L13.493 19.777zM4 15h2V8H4c-1.103 0-2 .897-2 2v3C2 14.103 2.897 15 4 15z"
      ></path>
    </svg>

    <span class="d-block font-weight-bold">Deixe sua sugestão</span>
    <span class="d-block mx-auto texto__descricao">
      Colabore conosco! O seu feedback faz toda a diferença 💙
      <a
        target="_blank"
        class="text-light d-block"
        href="https://klausfiscal.com.br/enviar-sugestao/"
      >
        <u>Nos envie seu feedback!</u>
      </a>
    </span>
  </b-alert>
</template>

<script>
export default {};
</script>

<style scoped>
.feedback-wrapper {
  background: #007fff;
  color: #fff;
  padding: 15px;
  width: 95%;
  margin: 0 auto;
}

@media (min-width: 920px) {
  .feedback-wrapper {
    bottom: 5vh;
    right: 20px;
    position: fixed;
    width: 30vw;
    border-radius: 5px;
    padding: 15px 5px;
  }

  .texto__descricao {
    width: 90%;
  }
}
</style>